import { apiRequest } from './api';

export enum SearchBackend {
  SUPABASE = 'supabase',
  TURBOPUFFER = 'turbopuffer',
}

export interface SearchFilters {
  company_id?: string;
  fiscal_year?: string;
  fiscal_quarter?: string;
  calendar_year?: string;
  calendar_quarter?: string;
  category?: string;
  type?: string;
}

interface SearchResult {
  similarity: number;
  documentName: string;
  companyName: string;
  content: string;
  id: string;
}

interface SearchResponse {
  results: SearchResult[];
  timeTaken: number;
}

export const testSearch = async (
  query: string,
  topK: number,
  backend: SearchBackend,
  namespace?: string,
  filters?: SearchFilters,
): Promise<SearchResponse> => {
  return apiRequest('/admin/search/test', {
    method: 'POST',
    data: { query, topK, backend, namespace, ...(filters || {}) },
  });
};
